import { gql } from "@apollo/client";

const PRICING_BUNDLE_FIELDS = gql`
  fragment PricingBundleFields on PricingBundle {
    id
    name
    type
    description
    prices {
      id
      priceInMillicents
      sku {
        id
        name
        description
      }
    }
  }
`;

const TENANT_ASSIGNMENT_FIELDS = gql`
  ${PRICING_BUNDLE_FIELDS}
  fragment TenantAssignmentFields on TenantPricingBundleAssignment {
    id
    effectiveDate
    expirationDate
    reasonCode
    notes
    createdBy {
      email
      fullName
    }
    pricingBundle {
      ...PricingBundleFields
    }
  }
`;

const SUBACCOUNT_ASSIGNMENT_FIELDS = gql`
  ${PRICING_BUNDLE_FIELDS}
  fragment SubaccountAssignmentFields on SubaccountPricingBundleAssignment {
    id
    subaccountId
    subaccountName
    effectiveDate
    expirationDate
    reasonCode
    notes
    createdBy {
      email
      fullName
    }
    pricingBundle {
      ...PricingBundleFields
    }
  }
`;

export const GET_TENANT_PRICING = gql`
  ${TENANT_ASSIGNMENT_FIELDS}
  ${SUBACCOUNT_ASSIGNMENT_FIELDS}
  query GetTenantPricing {
    getTenantPricing {
      currentAssignment {
        ...TenantAssignmentFields
      }
      futureAssignments {
        ...TenantAssignmentFields
      }
      pastAssignments {
        ...TenantAssignmentFields
      }
      currentSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
      futureSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
      pastSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
    }
  }
`;
